import './observer.css';
import {useContext, useEffect, useMemo, useState} from "react";
import localizer from "./localizer";
import {BrowserLocalesContext} from "./BrowserLocalesProvider";

const Layout = (props: {children: JSX.Element}) => {

    const [isLocaleLoaded, setLocalLoaded] = useState(false);

    const supportedLocales = ['ru', 'en'];

    const browserLocales = useContext(BrowserLocalesContext);

    const russianSupportedByBrowser = useMemo(() => browserLocales.includes('ru'), [browserLocales]);

    const localeByPath = useMemo(() => {
        if(window.location.search.length <= 1){
            return null;
        }
        const l = window.location.search.slice(1, 3);
        if(l.length != 2){
            return null;
        }
        return supportedLocales.includes(l) ? l : null;
    }, [window.location.search]);

    useEffect(() => {

        let localeToSelect: string | null = localeByPath;
        if(localeByPath){
            localeToSelect = localeByPath;
        }else if(russianSupportedByBrowser){
            localeToSelect = 'ru';
        }

        if(!localeToSelect){
            supportedLocales.forEach(l => {
                if(browserLocales.includes(l)){
                    localeToSelect = l;
                    return;
                }
            });
        }

        if(!localeToSelect){
            localeToSelect = supportedLocales[supportedLocales.length - 1];
            return;
        }

        if(localeToSelect){
            localizer.changeLanguage(localeToSelect).then(() => setLocalLoaded(true));
        }

    }, [localeByPath, browserLocales]);

    return <>
        {isLocaleLoaded && props.children}
    </>;
};

export default Layout;